import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Switch, Table, TableBody, TableCell, TableHead, TableRow, ThemeProvider, useTheme } from '@mui/material';
import React, { useState, useEffect } from 'react';
export const FieldsDialog = ({ open, columns, values, onSubmit, close }) => {
    const [keys, setKeys] = useState({});
    const theme = useTheme();
    useEffect(() => {
        setKeys(values || {});
    }, [open, values]);
    const getKeyName = (key) => {
        return columns.find(r => r.accessorKey === key)?.header;
    };
    const handleKeyCheck = (event) => {
        const name = event.target.name;
        const checked = event.target.checked;
        setKeys(prev => ({ ...prev, [name]: checked }));
    };
    return (<>
      {<ThemeProvider theme={theme}>
          <Dialog open={open} onClose={close} maxWidth='sm' fullWidth>
            <DialogTitle>Editar campos visíveis</DialogTitle>

            <DialogContent>
              <Alert severity='info'>Utilize os botões para alterar os campos a mostrar na tabela.</Alert>
              <Paper elevation={0} sx={{ mt: 2, background: theme.palette.mode === 'dark' ? undefined : theme.palette.action.selected }}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ width: '90px' }}>Mostrar?</TableCell>
                      <TableCell align='left'>Campo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {columns.map(col => {
                const name = String(col.accessorKey);
                return (<TableRow key={name}>
                          <TableCell>
                            <Switch name={name} checked={keys[name] ?? true} onChange={handleKeyCheck}/>
                          </TableCell>
                          <TableCell align='left'>{col.header}</TableCell>
                        </TableRow>);
            })}
                  </TableBody>
                </Table>
              </Paper>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => {
                close();
            }}>
                Cancelar
              </Button>
              <Button onClick={() => { onSubmit?.(keys); close(); }} variant='outlined'>
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>}
    </>);
};
